import withPageContainer from '../shared/page-container/with-page-container';
import withIntl from '../shared/intl-hoc';

import tabs from './tabs';

export default Main => withPageContainer(withIntl(Main), {
	name: 'List of offers',
	tabs,
	permission: null
});


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/wrap-main.js